import * as amplitude from '@amplitude/analytics-browser'

export type ChartExportClickedProperties = {
  page: string
  widget_type: 'distribution' | 'timeline'
  dimension_or_granularity?: string
  row_count: number
  date_range_days?: number
  filters_applied: boolean
}

/**
 * TechDebt: tracked through the raw client because `Chart Export Clicked` is not in the generated
 * tracking plan. Add the event in Amplitude, run `ampli pull dashboard`, then call
 * `ampli.chartExportClicked()` and we can remove this wrapper.
 */
export function trackChartExportClicked(properties: ChartExportClickedProperties) {
  amplitude.track('Chart Export Clicked', properties)
}
